import { PowerIcon } from '@phosphor-icons/react';

import { hasPowerControl, powerActionLabel } from '../format';
import type { Device } from '../types';
import { useCommandLifecycle } from '../use-command-lifecycle';

import styles from './power-toggle.module.scss';

export type PowerToggleProps = {
  device: Device;
};

/**
 * Circular card power control (story 101847 / Figma card). Shown only for Electric pumps.
 * Lime when the device is running (tap → Turn Off), neutral when stopped (tap → Turn On).
 * While a command is in flight it's disabled and dimmed (no further actions until it
 * resolves); Disconnected devices queue the action the same way.
 */
export function PowerToggle({ device }: PowerToggleProps) {
  const { pending, run } = useCommandLifecycle(device);

  if (!hasPowerControl(device)) return null;

  const action = powerActionLabel(device);
  const running = action === 'Off';

  return (
    <button
      type="button"
      className={[
        styles.btn,
        running ? styles.on : styles.off,
        pending ? styles.pending : undefined,
      ]
        .filter(Boolean)
        .join(' ')}
      disabled={pending}
      aria-label={pending ? 'Command queued' : `Turn ${action}`}
      title={pending ? 'Action queued…' : `Turn ${action}`}
      onClick={() => run(running ? 'turn_off' : 'turn_on')}
    >
      <PowerIcon size={22} weight="bold" />
    </button>
  );
}
